// extracted by mini-css-extract-plugin
module.exports = {"loginbox":"loginbox_loginbox__1mAtr","formField":"loginbox_formField__3F7pD","loginButton":"loginbox_loginButton__3U6SV","error":"loginbox_error__94gYN"};